import { BaseClickable, Icons, NavBar, Stack, style, Text } from '@solvhealth/jigsaw-v1';
import Booking from '@solvhealth/types/interfaces/Booking';
import React, { useContext } from 'react';
import { ReviewContext } from '~/routes/addReview/context';
import { ADD_REVIEW_COPY_PASTE } from '../../constants';
import useFetchSingleProvider from '../ProviderGroup/hooks/useFetchSingleProvider';
import { getProviderName } from '../ProviderGroup/Provider/util';

type Props = {
  reviewStatus?: string;
  location?: any;
  booking: Booking;
};

const ReviewHeader = (props: Props) => {
  const { reviewStatus, location, booking } = props;

  const { provider } = useFetchSingleProvider(booking?.providerId);
  const { isModal } = useContext(ReviewContext)!;

  if (reviewStatus === ADD_REVIEW_COPY_PASTE) {
    return (
      <Stack bg="karl" px={2} space={1.5} textAlign="center">
        <Text variant="h3">Help others find great care!</Text>

        <Text muted>
          <span
            style={style({
              bg: 'gray-500',
              px: 0.5,
              fontWeight: 'medium',
              borderRadius: 'sm',
              textColor: 'karl',
              fontSize: 'xs',
              textTransform: 'uppercase',
              // @ts-ignore this works i promise
              letterSpacing: '0.01em',
            })}
          >
            Copy
          </span>{' '}
          and{' '}
          <span
            style={style({
              bg: 'gray-500',
              px: 0.5,
              fontWeight: 'bold',
              borderRadius: 'sm',
              textColor: 'karl',
              fontSize: 'xs',
              textTransform: 'uppercase',
              // @ts-ignore this works i promise
              letterSpacing: '0.01em',
            })}
          >
            Paste
          </span>{' '}
          your review to Google
        </Text>
      </Stack>
    );
  }

  return (
    <NavBar
      hideBackButton
      rightItem={
        isModal ? (
          <BaseClickable goBack p={2}>
            <Icons.Close size="small" />
          </BaseClickable>
        ) : null
      }
      subtitle={(provider ? `${getProviderName(provider)} - ` : '') + location?.name}
    >
      Rate and review
    </NavBar>
  );
};

export default ReviewHeader;
